import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-3"
}
const _hoisted_2 = {
  key: 1,
  class: "py-8 text-center text-gray-500"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Você ainda não está vinculado a nenhuma empresa.", -1)
const _hoisted_4 = {
  key: 2,
  class: "grid grid-cols-1 sm:grid-cols-2 gap-4"
}
const _hoisted_5 = { class: "flex items-center gap-3 min-w-0" }
const _hoisted_6 = { class: "text-sm font-bold text-white" }
const _hoisted_7 = { class: "min-w-0" }
const _hoisted_8 = { class: "text-base font-medium text-gray-900 truncate" }
const _hoisted_9 = { class: "text-xs text-gray-500" }
const _hoisted_10 = ["data-testid"]

import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { mdiOfficeBuildingOutline } from '@mdi/js'

import { useCompanyStore } from '@/pinia-store/useCompanyStore'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import PATHS from '@/router/paths'

import SettingsCard from '../atoms/SettingsCard.vue'
import { getInitials } from '../../helpers/profile'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationsPanel',
  setup(__props) {

const router = useRouter()
const { flags } = useFeatureFlags()
const companyStore = useCompanyStore()
const { myCompanies } = storeToRefs(companyStore)

const isLoading = ref(false)

const canManageAccess = computed(() => flags.enabledDSPoliciesPermissions)

const companiesLabel = computed(() => {
  const count = myCompanies.value.length
  if (!count) return 'Empresas às quais você tem acesso.'
  return count === 1 ? '1 empresa vinculada.' : `${count} empresas vinculadas.`
})

const goToAccessManager = () => router.push(PATHS.ACCESS_MANAGER)

onMounted(async () => {
  isLoading.value = true
  try {
    await companyStore.getMyCompanies()
  } finally {
    isLoading.value = false
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!

  return (_openBlock(), _createBlock(SettingsCard, {
    title: "Minhas empresas",
    description: companiesLabel.value
  }, {
    default: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
              return _createElementVNode("div", {
                key: n,
                class: "h-16 rounded-xl bg-gray-100 animate-pulse"
              })
            }), 64))
          ]))
        : (!_unref(myCompanies).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_v_icon, {
                size: "32",
                color: "grey-lighten-1",
                class: "mb-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(mdiOfficeBuildingOutline)), 1)
                ]),
                _: 1
              }),
              _hoisted_3
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(myCompanies), (company) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: company.id,
                  class: "flex items-center justify-between gap-3 rounded-xl border border-gray-100 p-4",
                  "data-testid": "organization-card"
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_v_avatar, {
                      color: "primary",
                      size: "44"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(getInitials)(company.name)), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("p", _hoisted_8, _toDisplayString(company.name), 1),
                      _createElementVNode("p", _hoisted_9, "Empresa #" + _toDisplayString(company.id), 1)
                    ])
                  ]),
                  (canManageAccess.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "shrink-0 text-sm font-medium text-primary hover:underline",
                        "data-testid": `organization-manage-access-${company.id}`,
                        onClick: goToAccessManager
                      }, " Gerenciar acesso ", 8, _hoisted_10))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
    ]),
    _: 1
  }, 8, ["description"]))
}
}

})